<template>
  <div class="user_info_box">
    <div class="my_header_box">
        <img class="my_header" :src="userInfo && userInfo.avatar ? userInfo.avatar : headImg"/>
        <div class="user_vip_box">
          <div class="user_vip_cont" :class="userInfo && userInfo.is_vip ? 'vip' : '' ">
            <span class="user_vip_icon"></span>
            <div class="user_vip_text">VIP</div>
          </div>
        </div>
      </div>
      <div class="my_info">
        <p class="my_name">{{ userInfo ? userInfo.name : '' }}</p>
        <p class="medlive_id">医脉通ID：{{ userInfo ? userInfo.medlive_id : 0 }}</p>
        <p class="vip_info" v-if="userInfo && userInfo.is_vip">您的VIP有效期至{{ userInfo.expire_date }}</p>
        <p class="vip_info" v-else>剩余次数：{{ totalNum }}</p>
      </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "UserInfoBox",
  data() {
    return {
      headImg: require("@/assets/avatar.png"),
      is_vip: false,
      totalNum: 0,
    }
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {
    console.log(this.userInfo);
    this.todayQaNum()
  },
  methods: {
    todayQaNum() { //今日问答剩余次数
      let params = {
        token: window.localStorage.getItem('token'),
      }
      this.$api.todayNum(params).then(res => {
        this.totalNum = res.data
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.user_info_box{
  .my_header_box{
    @apply w-[64px] h-[64px] mx-auto mt-5 mb-6 border-2 border-white rounded-full relative;
    .my_header{
      @apply w-full h-full rounded-full;
    }
    .user_vip_box{
      @apply relative mt-[-6px] z-10;
      .user_vip_cont{
        @apply w-full h-[18px];
        .user_vip_icon{
          background: url(@/assets/icon_free_h5.png) no-repeat;
          background-size: 100% auto;
          @apply w-[15.4px] h-5 absolute left-[3px] z-30;
        }
        .user_vip_text{
          background: linear-gradient(90deg, #D9DEE5 0%, #BEC6D0 100%);
          @apply text-[11px] text-[#626C7C] font-medium pl-[14px] py-[1px] pr-2 rounded-[9px] whitespace-nowrap absolute left-[10px] z-20;
        }
        &.vip{
           .user_vip_icon{
             background: url(@/assets/icon_vip_h5.png) no-repeat;
             background-size: 100% auto;
           }
          .user_vip_text{  
            background: linear-gradient(90deg, #FFFBF4 0%, #F7D9C3 100%);
            @apply text-[#7B5D41];
          }
        }
      }
      
    }
  }
  .my_info{
    @apply text-center mb-8;
    .my_name{
      @apply text-lg text-black;
    }
    .medlive_id{
      @apply text-xs text-[#A0A3AE];
    }
    .vip_info{
      @apply text-xs text-[#A0A3AE];
    }
  }
}
</style>